import { useContext, useState } from "react";
import { GlobalContext } from "store/globalContext";

const convertValue = (value, type) => {
  switch (type) {
    case "number":
      return Number(value);
    default:
      return String(value);
  }
};

export const useStorageState = ({
  key,
  type = "string",
  defaultState = null,
}) => {
  const { userData } = useContext(GlobalContext);
  const name = `${userData?.cognitoId}-${key}`;
  const rawData = localStorage.getItem(name);
  const [state, setState] = useState(
    rawData ? convertValue(rawData, type) : defaultState
  );

  const storeAndSetState = (newState) => {
    localStorage.setItem(name, newState);
    switch (type) {
      case "number":
        setState(convertValue(newState, type));
        break;
      default:
        setState(convertValue(newState, type));
    }
  };

  return [state, storeAndSetState];
};
